import { useState } from "react";
import { BsFiletypePdf } from "react-icons/bs";
import ModalLoadingPage from "../../../components/modal/loadingPage";
import { dataTel3GetDetailPart } from "../../../config/apiSPA";
import Tel3PdfGenerator from "../../../services/pdfGenerator/tel3PdfGenerator";

export default function IconParticipant({ val, onDelete, onShowLink, onRelink }) {
  const hasLink = !!val.link;
  const hasSignature = !!val.signaturePath;
  const isEvaluator = !!val.evaluator;
  const [modalGenPdf, setModalGenPdf] = useState({ show: false, text: "Preparing your PDF..." });

  const onGeneratePdf = async (e) => {
    try {
      setModalGenPdf((a) => ({ ...a, show: true }));
      const res = await dataTel3GetDetailPart(e);
      await Tel3PdfGenerator(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setModalGenPdf((a) => ({ ...a, show: false }));
    }
  };
  const renderLinkIcon = () =>
    hasLink ? (
      <a href="#/" onClick={() => onShowLink(val.link)} title="show link">
        <i className="fas fa-link mx-2"></i>
      </a>
    ) : (
      <i className="fas fa-link mx-2"></i>
    );

  const renderDeleteIcon = () =>
    hasSignature ? (
      <i className="fas fa-trash mx-2"></i>
    ) : (
      <a href="#/" onClick={() => onDelete(val.id)} className="mx-2" title="delete this participant">
        <i className="text-danger fas fa-trash"></i>
      </a>
    );

  const renderRelinkIcon = () =>
    hasSignature ? (
      <i className="fas fa-redo mx-2"></i>
    ) : (
      <a href="#/" onClick={() => onRelink(val.id)} className="mx-2" title="regenerate link">
        <i className="fas fa-redo"></i>
      </a>
    );

  const renderGenerateIcon = () =>
    hasSignature ? (
      <a href="#/" onClick={() => onGeneratePdf(val.id)} title="generate pdf">
        <BsFiletypePdf />
      </a>
    ) : (
      <BsFiletypePdf />
    );

  return (
    <>
      {isEvaluator ? renderLinkIcon() : <i className="fas fa-link mx-2"></i>}
      {/* {isEvaluator ? renderRelinkIcon() : <i className="fas fa-redo mx-2"></i>} */}
      {isEvaluator ? renderGenerateIcon() : <BsFiletypePdf />}
      {renderDeleteIcon()}
      <ModalLoadingPage hide={() => setModalGenPdf((a) => ({ ...a, show: false }))} show={modalGenPdf.show} text={modalGenPdf.text} />
    </>
  );
}
